import { getCurrentInstance as t, inject as i, unref as c } from "vue";
import { useGetDerivedNamespace as s } from "./index559.js";
import { debugWarn as u } from "./index588.js";
import { isClient as d, computedEager as a } from "./index599.js";
const r = {
  prefix: Math.floor(Math.random() * 1e4),
  current: 0
}, p = /* @__PURE__ */ Symbol("elIdInjection"), I = () => t() ? i(p, r) : r, v = (n) => {
  const e = I();
  !d && e === r && u(
    "IdInjection",
    `Looks like you are using server rendering, you must provide a id provider to ensure the hydration process to be succeed
usage: app.provide(ID_INJECTION_KEY, {
  prefix: number,
  current: number,
})`
  );
  const o = s();
  return a(
    () => c(n) || `${o.value}-id-${e.prefix}-${e.current++}`
  );
};
export {
  p as ID_INJECTION_KEY,
  v as useId,
  I as useIdInjection
};
